import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  RESTORE_DELETED_BUSINESS_CLEAR_BUSINESS_INFO,
  RESTORE_DELETED_BUSINESS_LOG_SET_DATA,
  RESTORE_DELETED_BUSINESS_LOG_SET_ERRORS,
  RESTORE_DELETED_BUSINESS_LOG_SET_IS_LOADING,
  RESTORE_DELETED_BUSINESS_LOG_SET_SHOWN,
  RESTORE_DELETED_BUSINESS_SET_BUSINESS_INFO,
  RESTORE_DELETED_BUSINESS_SET_SEARCH_ERROR,
  RESTORE_DELETED_BUSINESS_SET_SEARCH_LOADING,
  RESTORE_DELETED_BUSINESS_SET_SUBMIT_ERROR,
  RESTORE_DELETED_BUSINESS_SET_SUBMIT_LOADING,
  RESTORE_DELETED_BUSINESS_SET_SUBMIT_SUCCESS,
} from 'state/actionTypes';

const searchInitialState = {
  isLoading: false,
  error: null,
};

const search = createReducer(searchInitialState, {
  [RESTORE_DELETED_BUSINESS_SET_SEARCH_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [RESTORE_DELETED_BUSINESS_SET_SEARCH_ERROR]: (draft, { payload }) => {
    draft.error = payload.error;
  },
  [RESTORE_DELETED_BUSINESS_CLEAR_BUSINESS_INFO]: draft => {
    draft.error = null;
  },
});

const businessInfo = createReducer(null, {
  [RESTORE_DELETED_BUSINESS_SET_BUSINESS_INFO]: (state, { payload }) =>
    payload.businessInfo,
  [RESTORE_DELETED_BUSINESS_CLEAR_BUSINESS_INFO]: () => null,
});

const submitInitialState = {
  isLoading: false,
  error: null,
  success: false,
};

const submit = createReducer(submitInitialState, {
  [RESTORE_DELETED_BUSINESS_SET_SUBMIT_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [RESTORE_DELETED_BUSINESS_SET_SUBMIT_ERROR]: (draft, { payload }) => {
    draft.error = payload.error;
    draft.success = false;
  },
  [RESTORE_DELETED_BUSINESS_SET_SUBMIT_SUCCESS]: (draft, { payload }) => {
    draft.success = payload.success;
    draft.error = null;
  },
});

const logModalInitialState = {
  shown: false,
  isLoading: false,
  data: [],
  paging: {
    page: 1,
    size: 20,
    total: 0,
  },
  errors: [],
};

const log = createReducer(logModalInitialState, {
  [RESTORE_DELETED_BUSINESS_LOG_SET_SHOWN]: (draft, { payload }) => {
    draft.shown = payload.shown;
  },
  [RESTORE_DELETED_BUSINESS_LOG_SET_DATA]: (draft, { payload }) => {
    draft.data = payload.data;
    draft.paging = payload.paging;
  },
  [RESTORE_DELETED_BUSINESS_LOG_SET_IS_LOADING]: (draft, { payload }) => {
    draft.isLoading = payload.isLoading;
  },
  [RESTORE_DELETED_BUSINESS_LOG_SET_ERRORS]: (draft, { payload }) => {
    draft.errors = payload.errors;
  },
});

export default combineReducers({
  search,
  businessInfo,
  submit,
  log,
});
